// Marvel Characters - Ranked by Comic Appearances
// Difficulty: MEDIUM - Marvel knowledge required

export const marvelCharactersData = [
  { id: 1, name: "Spider-Man", rank: 1, image: "/images/marvel/spider_man.png" },
  { id: 2, name: "Iron Man", rank: 2, image: "/images/marvel/iron_man.png" },
  { id: 3, name: "Captain\nAmerica", rank: 3, image: "/images/marvel/captain_america.png" },
  { id: 4, name: "Wolverine", rank: 4, image: "/images/marvel/wolverine.png" },
  { id: 5, name: "Thor", rank: 5, image: "/images/marvel/thor.png" },
  { id: 6, name: "Hulk", rank: 6, image: "/images/marvel/hulk.png" },
  { id: 7, name: "Deadpool", rank: 7, image: "/images/marvel/deadpool.png" },
  { id: 8, name: "Black\nWidow", rank: 8, image: "/images/marvel/black_widow.png" },
  { id: 9, name: "Doctor\nStrange", rank: 9, image: "/images/marvel/doctor_strange.png" },
  { id: 10, name: "Black\nPanther", rank: 10, image: "/images/marvel/black_panther.png" },
  { id: 11, name: "Hawkeye", rank: 11, image: "/images/marvel/hawkeye.png" },
  { id: 12, name: "Scarlet\nWitch", rank: 12, image: "/images/marvel/scarlet_witch.png" },
  { id: 13, name: "Daredevil", rank: 13, image: "/images/marvel/daredevil.png" },
  { id: 14, name: "Doctor\nDoom", rank: 14, image: "/images/marvel/doctor_doom.png" },
  { id: 15, name: "Magneto", rank: 15, image: "/images/marvel/magneto.png" },
  { id: 16, name: "Loki", rank: 16, image: "/images/marvel/loki.png" },
  { id: 17, name: "The Punisher", rank: 17, image: "/images/marvel/punisher.png" },
  { id: 18, name: "Cyclops", rank: 18, image: "/images/marvel/cyclops.png" },
  { id: 19, name: "Storm", rank: 19, image: "/images/marvel/storm.png" },
  { id: 20, name: "Professor X", rank: 20, image: "/images/marvel/professor_x.png" },
  { id: 21, name: "Thanos", rank: 21, image: "/images/marvel/thanos.png" },
  { id: 22, name: "Ant-Man", rank: 22, image: "/images/marvel/ant_man.png" },
  { id: 23, name: "The Thing", rank: 23, image: "/images/marvel/the_thing.png" },
  { id: 24, name: "Human\nTorch", rank: 24, image: "/images/marvel/human_torch.png" },
  { id: 25, name: "Invisible\nWoman", rank: 25, image: "/images/marvel/invisible_woman.png" },
  { id: 26, name: "Mister\nFantastic", rank: 26, image: "/images/marvel/mister_fantastic.png" },
  { id: 27, name: "Nick Fury", rank: 27, image: "/images/marvel/nick_fury.png" },
  { id: 28, name: "Gambit", rank: 28, image: "/images/marvel/gambit.png" },
  { id: 29, name: "Rogue", rank: 29, image: "/images/marvel/rogue.png" },
  { id: 30, name: "Silver\nSurfer", rank: 30, image: "/images/marvel/silver_surfer.png" },
];
